import React, { useState, useEffect, useMemo } from "react";
import { Box, IconButton } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useDispatch, useSelector } from "react-redux";
import { setModal } from "../features/modal/ModalSlice";
import apiClient from "../services/apiClient";
import { MdDelete } from "react-icons/md";

import SearchIcon from "@mui/icons-material/Search";
import PageLoader from "../components/Loading/PageLoader";
import CustomButton from "../components/Button/CustomButton";
import CustomInputBox from "../components/Form/CustomInputBox";

const InvitePage = () => {
  const [inviteResults, setInviteResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state?.userInfo?.user);

  const columns = useMemo(
    () => [
      { accessorKey: "email", header: "Email" },
      { accessorKey: "invite_status", header: "Invite Status" },
      // { accessorKey: "stage_no", header: "Stage No" },
      { accessorKey: "company_details.company_name", header: "Company Name" },
      // { accessorKey: "company_details.domain", header: "Domain" },
      { accessorKey: "created_at", header: "Created At" },
      // { accessorKey: "invited_by_details.email_id", header: "Invited By" },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data: inviteResults,
    enableColumnOrdering: true,
    enableRowSelection: true,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableRowActions: true,
    enablePagination: false,
    positionActionsColumn: "last",
    renderRowActions: () => (
      <IconButton>
        <MdDelete />
      </IconButton>
    ),
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#F5F6F8",
      },
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
      },
    },
  });

  useEffect(() => {
    const fetchInvites = async () => {
      setLoading(true);
      try {
        const response = await apiClient.get(`/invites?invited_by=${userInfo?.id}`);
        setInviteResults(response?.data || []);
      } catch (error) {
        console.error("Error fetching invites:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInvites();
  }, []);

  const handleAddMember = () => {
    dispatch(setModal({ type: "ADD_MEMBER" }));
  };

  return (
    <>
      {loading && <PageLoader text="Loading Invites" />}

      <div className="pageTitle1 p-5">
        <h3>Invites</h3>
        <p>{inviteResults?.length} Available</p>
      </div>
      <Box sx={{ padding: 2 }}>
        <div className="d-flex justify-content-between">
          <div className="w-50">
            <CustomInputBox
              icon={SearchIcon}
              placeholder="Search Team Members"
              type="text"
              backgroundColor={"#FFFFFF"}
              borderRadius="8px"
            />
          </div>

          <div className="d-flex justify-content-end gap-3 mb-4">
            {/* <CustomButton
              text={(showFilter ? "Hide" : "Show") + " Filter"}
              color="secondary"
              iconPosition="left"
              icon={showFilter ? <MdFilterListOff /> : <MdFilterList />}
              onClick={handleShowFilter}
            /> */}

            <CustomButton text={"Add Invites"} onClick={handleAddMember} />
          </div>
        </div>
        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 2,
          }}
        >
          <Typography variant="h4">Create Invitations</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddMember}
            sx={{ marginRight: 1 }}
          >
            Add Invite
          </Button>
        </Box> */}

        <Box sx={{ marginTop: 4 }}>
          <MaterialReactTable table={table} />
        </Box>
      </Box>
    </>
  );
};

export default InvitePage;
